import { ColDef } from 'ag-grid-enterprise'

import { createTagCellEditor } from '@/ag-grid/columns/tag-column/cell-editor'
import { TagsCellRenderer } from '@/ag-grid/columns/tag-column/renderer'

/**
 * Assumes the value of the tags comes in the shape of single, comma separated value string.
 */
export const tagsColDef = <TData extends Record<string, unknown> = any>(
  options: ColDef<TData>,
): ColDef<TData> => {
  return {
    ...options,
    valueGetter: (params) => {
      const originalValue = getByPath(params.data!, options.field!)

      if (originalValue && typeof originalValue === 'string') {
        return originalValue.split(',')
      }
      return []
    },
    valueSetter: (params) => setByPath(params.data, options.field!, params.newValue.join(',')),
    cellRenderer: TagsCellRenderer,
    cellEditor: createTagCellEditor({ singularPhrase: 'Recipient', pluralPhrase: 'Recipients' }),
  } satisfies ColDef<TData>
}

const getByPath = (obj: Record<string, unknown>, path: string): unknown => {
  return path.split('.').reduce<unknown>((current, key) => {
    if (current == null || typeof current !== 'object') {
      return undefined
    }

    return (current as Record<string, unknown>)[key]
  }, obj)
}

const setByPath = (obj: Record<string, unknown>, path: string, value: unknown) => {
  const parts = path.split('.')

  let current: Record<string, unknown> = obj

  while (parts.length > 1) {
    const key = parts.shift()!

    if (current[key] == null || typeof current[key] !== 'object') {
      return false
    }

    current = current[key] as Record<string, unknown>
  }

  current[parts[0]] = value

  return true
}
